import React from 'react';
import { SvgIcon } from 'material-ui';

const ArrowDownIcon = props => (
  <SvgIcon {...props} viewBox='0 0 7 5' style={props.style}>
    <g
      id='2'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-303.000000, -405.000000)'
    >
      <polygon id='arrow' fill='#ADADAD' points='306.5 410 303 405 310 405' />
    </g>
  </SvgIcon>
);

export default ArrowDownIcon;



// WEBPACK FOOTER //
// ./src/icons/ArrowDownIcon.js